import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import { getNotifications } from '@/components/admin/users/users.service'
import SignalRServiceClass from '@/SignalRService'
import { DoctorInsurance, NotificationMessage } from '@/models'
@Module({ namespaced: true })
class AppModule extends VuexModule {
  public isLoading = false
  public takesLong = false
  public closeModal = false
  public progress = 0
  public isUploading = false
  public messages: Notification[] = []
  public messageCount = 0
  public toastMessage: Notification = null
  public signalRService: SignalRServiceClass | null = null
  public massiveNotificationShowed = false
  public isUploadCompleted = false
  public userInsurances: DoctorInsurance[] = null

  @Action
  initSignalR(userId: string) {
    this.context.commit('setSignalRService', userId)
  }
  @Action
  stopSignalR(userId: string) {
    this.context.commit('stopSignalRService', userId)
  }
  @Action
  public async sendSignalRMessage(payload: NotificationMessage) {
    if (this.signalRService) {
      // console.log(payload.userId, payload.message)
      await this.signalRService.sendMessage(payload)
    }
  }

  @Mutation
  async setSignalRService(userId: string) {
    if (this.signalRService) {
      return
    }
    this.signalRService = new SignalRServiceClass(userId)
    await this.signalRService.startConnection()
  }
  @Mutation
  stopSignalRService(userId: string) {
    this.signalRService.stopConnection()
    this.signalRService = null
  }

  @Mutation
  setToastMessage(message: Notification) {
    this.toastMessage = message
  }
  @Action
  addLoading(isLoading: boolean) {
    this.context.commit('setLoading', isLoading)
  }
  @Action
  addTakesLong(takesLong: boolean) {
    this.context.commit('setTakesLong', takesLong)
    //console.log(takesLong)
  }
  @Action
  addProgress(progress: number) {
    this.context.commit('setProgress', progress)
  }
  @Action
  addMessage(message: string) {
    //console.log(message)
    this.context.commit('setMessage', message)
  }
  @Action
  async fetchNotifications(userId: string) {
    await getNotifications(userId).then(c => {
      this.context.commit('setNotifications', c.data)
    })
  }

  @Mutation
  setNotifications(notifications: Notification[]) {
    this.messages = notifications
  }

  @Action
  massiveLoadNotifications(flag: boolean) {
    this.context.commit('setMassiveLoadNotifications', flag)
  }

  @Mutation
  setMassiveLoadNotifications(flag: boolean) {
    this.massiveNotificationShowed = flag
  }

  @Action
  setUploadCompletedFlag(flag: boolean) {
    this.context.commit('setUploadCompleted', flag)
  }

  @Mutation
  setUploadCompleted(flag: boolean) {
    this.isUploadCompleted = flag
  }

  @Mutation
  setLoading(isLoading: boolean) {
    this.isLoading = isLoading
  }
  @Mutation
  setTakesLong(takesLong: boolean) {
    this.takesLong = takesLong
  }
  @Mutation
  setMessage(message: Notification) {
    this.messages.push(message)
  }

  @Mutation
  setProgress(progress: number) {
    this.progress = progress
    if (this.progress > 0 && this.progress < 100) {
      this.isUploading = true
    } else {
      this.isUploading = false
    }
  }
  @Action
  addCloseModal() {
    this.context.commit('setCloseModal')
  }

  @Mutation
  setCloseModal() {
    this.closeModal = true
  }

  @Action
  addUserInsurance(insurance: DoctorInsurance[]) {
    this.context.commit('setUserInsurance', insurance)
  }

  @Mutation
  setUserInsurance(insurance: DoctorInsurance[]) {
    this.userInsurances = insurance
    const ids =
      insurance
        ?.map(c => c.insuranceID)
        .filter(id => id != null)
        .join(',') || ''
    localStorage.setItem('userInsurances', ids)
  }

  @Mutation
  setDefaultStore() {
    this.userInsurances = null
    this.messages = []
    localStorage.removeItem('userInsurances')
  }

  @Action
  resetStore() {
    this.context.commit('setDefaultStore')
  }

  get _closeModal() {
    return this.closeModal
  }

  get _getUserInsurances() {
    return this.userInsurances
  }
  get _getUserInsurancesID() {
    return this.userInsurances?.map(c => c.insuranceID)
  }
  get _getUserInsurancesName() {
    return this.userInsurances?.map(c => c.insuranceName)
  }

  get _messages() {
    return this.messages
  }
  get _isLoading() {
    return this.isLoading
  }
  get _takesLong() {
    return this.takesLong
  }
  get _progress() {
    return this.progress
  }
  get _isUploadCompleted() {
    return this.isUploadCompleted
  }

  get _isUploading() {
    return this.isUploading
  }
  get _messageCount() {
    return this.messages.length
  }
  get getSignalRService() {
    return this.signalRService
  }

  getDefaultState() {
    return {
      isLoading: false,
      takesLong: false,
      closeModal: false,
      progress: 0,
      isUploading: false,
      messages: [] as Notification[],
      messageCount: 0,
      toastMessage: null as Notification | null,
      signalRService: null as SignalRServiceClass | null,
      massiveNotificationShowed: false,
      isUploadCompleted: false,
      userInsurances: null as DoctorInsurance[] | null
    }
  }
}
export default AppModule
